import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import {getEmployeeBranch} from "../../account/user/user-info/user-info";

let _deviceData;

export default function (deviceData) {
    _deviceData = deviceData;
    setUpAutoComplete();
    setUpDropDownList();
    transferDeviceButton();
}

const setUpAutoComplete = () => {
    const k_autocomplete = $('.autocomplete input').data('kendoAutoComplete');
    if (k_autocomplete) return;
    $('.autocomplete').kendoAutoComplete({
        dataSource: {
            schema: {
                autoSync: true,
                id: 'id',
                fields: {
                    id: {
                        type: 'number'
                    },
                    accountNumber: {
                        type: 'string'
                    }
                }
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'POST',
                    url: '/Forms/ProjectReview/AllEmployeesAutoComplete'
                },
                parameterMap(data, type) {
                    if (type === 'read') {
                        // data.company = _company;
                        // data.salesperson = _salesperson;
                    }
                    return data;
                }
            }
        },
        filter: 'contains',
        placeholder: 'Enter Search Terms...',
        noDataTemplate: 'No matching users found.',
        change(e) {
            getEmployeeBranch(e.sender.value())
                .then((branch) => {
                    setBranchTransferDropdown(branch);
                });
        }
    }).data('kendoAutoComplete');
}

const setBranchTransferDropdown = (branch) => {
    const $dropdownList = $('.dropdownList.branch-options select');
    const k_dropdownList = $dropdownList.data('kendoDropDownList');
    if (!k_dropdownList) return;

    k_dropdownList.value(Number(branch));
    k_dropdownList.enable(branch === '');
}

const setUpDropDownList = () => {
    const $dropdownList = $('.dropdownList.branch-options');
    const k_dropdownList = $dropdownList.kendoDropDownList({
        optionLabel: 'Select branch...',
        dataTextField: 'value', dataValueField: 'Company', dataSource: {
            transport: {
                read: {
                    url: `/Technology/AssetManagement/GetBranchOptions?type=${_deviceData.deviceType}`
                }
            }
        },
        change(e) {
            const selectedValue = e.sender.value();
            enableAssignedUser(selectedValue === '');
        }
    }).data('kendoDropDownList');
}

const enableAssignedUser = (enable) => {
    $('.autocomplete input').data('kendoAutoComplete').enable(enable);
}

const transferDeviceButton = () => {
    $('#transfer-device').on('click', transferDevice);
}
const transferDevice = function (e) {
    const deviceWrapper = $('#device-details');
    const url = `/Technology/AssetManagement/TransferDevice`;
    const data = {
        type: _deviceData.deviceType,
        deviceId: _deviceData.deviceId,
        transferToBranch: _deviceData.deviceId
    };

    let employeeValue = $('#transferToEmp').data('kendoAutoComplete').value();
    data['transferToEmp'] = employeeValue.substr(0, employeeValue.indexOf('-')).trim();
    const $dropdownList = $('.dropdownList.branch-options select');
    const k_dropdownList = $dropdownList.data('kendoDropDownList');
    data['transferToBranch'] = k_dropdownList.text();
    deviceWrapper.find('[id]').not('button').each((a, o) => {
        const ele = $(o);
        data[ele.attr('id')] = ele.val();
    });

    $.post(url, data, saveDeviceDetailsSuccess);
}

const saveDeviceDetailsSuccess = function (e) {
    if (e.success) {
        showSuccessNotification(e.message);
        $('.js-tech-asset-grid').data('kendoGrid').dataSource.read();
        $('#device-transfer-window').data('kendoWindow').close();
        return;
    }
    showErrorNotification(e.message);
};